import formAppThirdPartyAuthProviderSetup from './formAppThirdPartyAuthProviderSetup';
import formAppThirdPartyAuthProviderAppearance from './formAppThirdPartyAuthProviderAppearance';
import formAppThirdPartyAuthProviderUserCodeView from './formAppThirdPartyAuthProviderUserCodeView';


export default {
  title: 'Third Party Auth Provider',
  attributeName:'thirdPartyAuthProvider',
  createURL: '',
  sessionParams: [],
  getURL: 'appId/thirdPartyProvider',
  updateURL: 'appId/thirdPartyProvider',
  sessionParams: ['appId'],
  noArea: true,
  goBack: false,
  noUpdateWithId: true,
  autoUpdate: false,
  updateFormAfterSave: true,
  formConfig: [
    formAppThirdPartyAuthProviderSetup,
    formAppThirdPartyAuthProviderAppearance,
    formAppThirdPartyAuthProviderUserCodeView
  ],
};
